import { Component, OnInit, Input, DoCheck, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PATTERNS } from "../../../../globals";
import { UserService } from "../../../../injections/user.service";

@Component({
    selector: 'user-address',
    templateUrl: '../../templates/partials/user-address.html'
})
export class UserAddressComponent implements OnInit {

    @Input() addresses;
    @Output() emitCloseModal = new EventEmitter();
    public editFactData: boolean = false;
    
    constructor(private _fb: FormBuilder, private userService: UserService) { }

    public showModalAddress(type: string, address? : object, index? : any) {
        if(index != null) address["index"] = index;
        var object = {
            action: "open",
            data: address,
            type: type
        }
         
        this.emitCloseModal.emit(object);
    }

    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/user-address.component.ts